<template>
  <div>
    <event-list list-type="dense" :max-height="maxHeight" v-if="events.length" :events="events" disable-grouping show-list></event-list>
    <v-card-text v-if="!events.length">
      Δεν υπάρχουν βλάβες ή συντηρήσεις
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-btn text color="primary" to="/history"> ΌΛΕΣ</v-btn>
    </v-card-actions>
  </div>

</template>

<script>
import {mapActions} from "vuex";
import EventList from "@/views/Events/components/EventList";
export default {
  name: "RecentEvents",
  components: {EventList},
  data:()=>({
    events:[]
  }),
  props:{
    flat:{type:Boolean, default:false,},
    showStats:{type:Boolean, default:false},
    maxHeight:{type:String, default:'50vh'}
  },
  created() {
    this.getAllEvents({LastDays: 120, Status_ID:1}).then(events=>{
      let sortedEvents = events.sort((a,b)=>new Date(b.DateEventInsert) - new Date(a.DateEventInsert));
      if(sortedEvents.length > 50){
        sortedEvents = sortedEvents.slice(0,50)
      }else {
        sortedEvents = sortedEvents.slice(0,sortedEvents.length)
      }
      this.events = sortedEvents;
    })
  },
  methods:{
    ...mapActions([
        'getAllEvents'
    ])
  }
}
</script>

<style scoped>

</style>